var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6,8.1c-0.1,1.7-1.3,4-3.5,6.9c-2.4,3.1-4.4,4.6-6,4.6c-1,0-1.9-0.9-2.6-2.8c-0.5-1.7-0.9-3.4-1.4-5.1 C6.6,9.8,6.1,8.9,5.5,8.9c-0.1,0-0.6,0.3-1.4,0.8L3.3,8.6C4.2,7.9,5,7.1,5.8,6.4c1.1-1,2-1.5,2.6-1.6c1.3-0.1,2.2,0.8,2.5,2.8 c0.3,2.1,0.6,3.5,0.7,4c0.4,1.8,0.8,2.7,1.3,2.7c0.4,0,0.9-0.6,1.6-1.7c0.7-1.1,1.1-2,1.2-2.6c0.1-1-0.3-1.5-1.2-1.5 c-0.4,0-0.8,0.1-1.3,0.3c0.9-2.8,2.5-4.1,4.9-4.1C19.9,4.6,20.7,5.8,20.6,8.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.4285f7659514b247ac6bccc6dc520718.svg";
export { ForwardRef as ReactComponent };